import React from "react";
import { PD_EMAIL } from "./operator";

export function Section({ id, title, children }) {
  return (
    <section id={id} className="policy-section">
      <h2 className="policy-heading">{title}</h2>
      {children}
    </section>
  );
}

export function List({ items }) {
  return (
    <ul className="policy-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export const MailLink = () => (
  <a className="policy-link" href={`mailto:${PD_EMAIL}`}>
    {PD_EMAIL}
  </a>
);
